// extracted by mini-css-extract-plugin
export default {"div":"date_div__rOho2","input":"date_input__-kplu","err":"date_err__uFQqA","label":"date_label__96eQs","msg":"date_msg__XC4A+","highlight":"date_highlight__SFM7A"};